import axios from "axios";

const backend = process.env.VUE_APP_WK_INTEGRATION_LAYER + '/api/v0/sistic';
const sip_backend = process.env.VUE_APP_WK_INTEGRATION_LAYER + '/sip';
const content_backend = process.env.VUE_APP_WK_INTEGRATION_LAYER + '/api/v0/content';
const crm_endpoint = process.env.VUE_APP_WK_INTEGRATION_LAYER + '/crm';
const me_endpoint = process.env.VUE_APP_WK_INTEGRATION_LAYER + '/ciam/me'

/* languages = {
    en: English
    tc: Chinese Traditional
    sc: Chinese Simplified
  }
*/

function getHeaderToken() {
  var tokenMatch = document.cookie.match(new RegExp('(^| )' + 'wktoken' + '=([^;]+)'));
  if (tokenMatch) {
      return tokenMatch[2];
  } else {
      return '';
  }
}


function getSisticLocale(language) {
  switch (language) {
    case 'en':
      return 'EN_SG';
    case 'tc':
      return 'ZH_HK';
    case 'sc':
      return 'ZH_CN';
    default:
      return 'EN_SG';
  }
}

async function offlineCheck() {
  // If browser is offline
  if (!navigator.onLine) {
    console.warn('User is offline, lets try to await reconnection')

    // Max amount of times we're willing to check if the user has returned to internet service
    const MAX_RECONNECT_TRIES = 20

    // How long we should wait before assessing offline status again (in milliseconds)
    const WAIT_TIME = 3000

    let i = 0;

    while (i < MAX_RECONNECT_TRIES) {
      if (!navigator.onLine) {
        console.log('Waiting to reconnect, attempt: ', i, ' of ', MAX_RECONNECT_TRIES)
        await offlineWait(WAIT_TIME);
        i++;
      } else {
        console.log('User is back online!')
        i = MAX_RECONNECT_TRIES;
      }
    }
  }

  return;
}

async function offlineWait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class wkAPI {

  // Get main site information, this is used for header and footer links
  // Capital M is important
  getMainSite(language = 'en') {
    return axios.get(
      `${content_backend}/public/site/Main?language=${language}`,
      {headers: {'X-Id': getHeaderToken()}}
    );
  }

  getHeaderFooter(language = 'en') {
    return axios.get(
      `${content_backend}/public/site/${process.env.VUE_APP_MAIN_ENTITY_UUID}?language=${language}`
    );
  }

  getAnnouncements(language = 'en') {
    // let data = JSON.stringify({
    //   "references": [
    //     "announcements"
    //   ]
    // });

    // let config = {
    //   method: 'post',
    //   url: `${content_backend}/public-post/${process.env.VUE_APP_ANNOUNCEMENT_UUID}?language=${language}&preview=0`,
    //   data : data
    // };

    // return axios.request(config);

    return axios.get(
      `${content_backend}/public/${process.env.VUE_APP_ANNOUNCEMENT_UUID}?language=${language}`
    );
  }

  // Get information relating to an ICC code from the drupal backend
  getDrupalEvent(iccCode, language = "en") {
    return axios.get(
      `${content_backend}/public/icc/${iccCode}?language=${language}`
    );
  }

  // Get information relating to an ICC code from the drupal backend
  getEventByProduct(product) {
    return axios.get(
      `${content_backend}/public/product/${product}`
    );
  }

  // Get sessions for a drupal UUID
  getDrupalNode(uuid, language = "en", queryParams) {
    if (queryParams.length > 0) {
      queryParams += `&language=${language}`
    } else {
      queryParams = `?language=${language}`
    }
    return axios.get(
      `${content_backend}/public/${uuid}${queryParams}`
    );
  }

  // Get sessions for a drupal UUID
  getSessionData(uuid, language = 'en', queryParams) {
    if (queryParams.length > 0) {
      queryParams += `&language=${language}`
    } else {
      queryParams = `?language=${language}`
    }

    return axios.get(
      `${sip_backend}/public/sessions/${uuid}${queryParams}`
    );
  }

  // Get user details
  getUserDetails() {
    // This creates an array of:
    // 1. key=value
    // 2. ""
    // 3. value

    var token = document.cookie.match(new RegExp('(^| )' + 'wktoken' + '=([^;]+)'));

    token = token[2];
    if (token) {
      return axios.post(
        `${crm_endpoint}/query?details=user-info`, null, {
        headers: {
          'X-Id': getHeaderToken()
        }
      });
    } else {
      throw new Error("No Token Found");
    }
  }

  getLoggedUser() {
    var token = document.cookie.match(new RegExp('(^| )' + 'wktoken' + '=([^;]+)'));

    token = token[2];
    if (token) {
      return axios.get(
        me_endpoint, 
        {
          withCredentials: true,
          headers: {
              'X-Id': getHeaderToken()
          }
        }
      );
    } else {
      throw new Error("No Token Found");
    }
  }

  // 2.2 API Get Event Show Date & Time
  async getEventDatesAndTimes(iccCode, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/icc/${iccCode}?lang=${language}`,
      {
        withCredentials: true
      }
    );
  }

  // 2.3 API Seatmap Overview
  async getSeatmapOverview(productID, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/performances/${productID}/seatmap/overview?lang=${language}`,
      {
        withCredentials: true
      }
    );
  }

  // 2.4 API SeatSection Availability
  async getSeatAvailabilityForSection(productID) {
    await offlineCheck();
    return axios.get(
      `${backend}/performances/${productID}/seatmap/availability`,
      {
        withCredentials: true
      }
    );
  }

  // 2.5.1 Get Seat Offer
  async getSeatOffer(productID, seatSectionId, priceCatId, mode, quantity, language = "en") {
    await offlineCheck();
    language = getSisticLocale(language);
    return axios.get(
      `${backend}/performances/${productID}/seatmap/seatoffer?quantity=${quantity}&mode=${mode}&seatSectionId=${seatSectionId}&priceCatId=${priceCatId}&lang=${language}`,
      {
        withCredentials: true
      }
    );
  }

  // 2.5.2 API Get Available Seats for 3D map
  async getAvailableSeats(productID, seatSectionId, priceCatId, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/performances/${productID}/seatmap/availableseats?seatSectionId=${seatSectionId}&priceCatId=${priceCatId}&lang=${language}`,
      {
        withCredentials: true
      }
    );
  }

  // 2.6.a API Release Seats
  async postReleaseSeats(productID, payload) {
    await offlineCheck();
    return axios.post(
      `${backend}/performances/${productID}/releaseseat`, payload,
      {
        withCredentials: true,
        headers: {
            'X-Id': getHeaderToken()
        }
      }
    );
  }

  // 2.6.b API Reserve Seats
  async postReserveSeats(productID, payload) {
    await offlineCheck();
    return axios.post(
      `${backend}/performances/${productID}/reserveseat`, payload,
      {
        withCredentials: true
      }
    );
  }

  // 2.7.a API Ticket type - all
  async getAllTickets(productID, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/performances/${productID}/tickettype?lang=${language}`,
      {
        withCredentials: true
      }
    );
  }

  // 2.7.b API Ticket type - by priceCatId
  async getTicketsByPriceCategory(productID, priceCategoryID, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/performances/${productID}/tickettype?priceCatId=${priceCategoryID}&lang=${language}`,
      {
        withCredentials: true
      }
    );
  }

  // 2.8.1.a API Add to cart
  async postTicketsToBasket(payload) {
    await offlineCheck();
    return axios.post(
      `${backend}/cart`, payload,
      {
        withCredentials: true,
        headers: {
            'X-Id': getHeaderToken()
        }
      }
    );
  }

  // 2.8.2 API Get cart
  async getCart(guid, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/cart/${guid}?lang=${language}`,
      {
        withCredentials: true,
        headers: {
            'X-Id': getHeaderToken()
        }
      }
    );
  }

  // 2.8.3 API Delete cartItem
  async deleteCartItem(guid, item) {
    await offlineCheck();
    return axios.delete(
      `${backend}/cart/${guid}`,
      {
        data: item,
        withCredentials: true,
        headers: {
          'X-Id': getHeaderToken()
        }
      }
    );
  }

  // 2.11. API Get Transaction (by ID)
  async getTransaction(transaction, language = "en") {
    await offlineCheck();
    return axios.get(
      `${backend}/orders/transaction/${transaction}?lang=${language}`,
      {
        withCredentials: true,
        headers: {
            'X-Id': getHeaderToken()
        }
      }
    );
  }

  submitEvent(eventId, payload) {
    return axios.post(
      `${sip_backend}/public/events/${eventId}/registrations/online`, 
      payload
    )
  }
}

export default new wkAPI();
